export let DESTINATION_TYPE = /*#__PURE__*/function (DESTINATION_TYPE) {
  DESTINATION_TYPE["CUSTOMER"] = "CUSTOMER";
  DESTINATION_TYPE["WAREHOUSE"] = "WAREHOUSE";
  return DESTINATION_TYPE;
}({});
export let SHIPPING_COMPANY = /*#__PURE__*/function (SHIPPING_COMPANY) {
  SHIPPING_COMPANY["UPS"] = "ups";
  SHIPPING_COMPANY["FEDEX"] = "fedex";
  SHIPPING_COMPANY["USPS"] = "usps";
  SHIPPING_COMPANY["DHL"] = "dhl";
  return SHIPPING_COMPANY;
}({});
export let Shortage = /*#__PURE__*/function (Shortage) {
  Shortage["WarehouseASN"] = "WarehouseASN";
  return Shortage;
}({});
export let StallHistoryItemType = /*#__PURE__*/function (StallHistoryItemType) {
  StallHistoryItemType["STALL"] = "STALL";
  StallHistoryItemType["RESTALL"] = "RESTALL";
  StallHistoryItemType["UNSTALL"] = "UNSTALL";
  return StallHistoryItemType;
}({});
export let REPLACEMENT_ITEM_STATUSES = /*#__PURE__*/function (REPLACEMENT_ITEM_STATUSES) {
  REPLACEMENT_ITEM_STATUSES["REPLACEMENT_ITEM"] = "replacement-item";
  REPLACEMENT_ITEM_STATUSES["ORIGINAL_ITEM"] = "original-item";
  return REPLACEMENT_ITEM_STATUSES;
}({});